import bar_vue_vue_type_script_setup_true_lang_default from "./bar.vue_vue_type_script_setup_true_lang.mjs";

//#region ../../packages/components/scrollbar/src/bar.vue
var bar_default = bar_vue_vue_type_script_setup_true_lang_default;

//#endregion
export { bar_default as default };
//# sourceMappingURL=bar2.mjs.map